import { makeStyles } from '@material-ui/core/styles';
import Constants from '../../Constants'

export const useOrderPaymentStyle = makeStyles(theme => ({
    paper: {
        marginTop: theme.spacing(1),
        marginBottom: theme.spacing(3),
        padding: theme.spacing(2),
        boxShadow: '0 3px 20px rgba(0,0,0,.14118) !important',
        borderRadius: '9px ',
        [theme.breakpoints.up(1000 + theme.spacing(3) * 2)]: {
            marginTop: theme.spacing(2),
            marginBottom: theme.spacing(6),
            padding: theme.spacing(3),
        },
        minHeight: '30rem',
    },
    eirOrderPayment: {
        '& .leftPadding': {
            paddingLeft: theme.spacing(5),
        },

        '& h1': {
            fontSize: '40px',
            textAlign: 'left',
            '@media (max-width: 767px)': {
                fontSize: '24px',
                marginTop: '48px',
            },
        },

        '& iframe': {
            display: 'inline-block',
            displayContent: '5rem',
            width: '100%',
            align: 'centre',
            minHeight: '30rem',
            position: 'relative',
            marginTop: '1rem',
        },

        '& .errorMessage': {
            width: '100%',
            marginTop: '.25rem',
            fontSize: 16,
            color: '#e40046',
            display: 'block',
            '@media (max-width: 767px)': {
                textAlign: 'left',
                fontSize: 14,
            },
        },

        '& #pay-button': {
            visibility: 'hidden',
        },
    },
    eirButton: {
        borderRadius: '2rem',
        fontSize: 18,
        textTransform: 'initial',
        padding: '8px 45px',
        border: '1px solid ' +Constants.siteTheme.primaryTheme,
        background: Constants.siteTheme.primaryTheme,
        color: '#fff',
        '@media (min-width:280px) and (max-width: 320px)': {
            fontSize: 12,
            padding: '6px 22px',
        },
        '@media (min-width:321px) and (max-width: 767px)': {
            padding: '8px 30px',
            fontSize: 16,
        },
        '@media (min-width:768px) and (max-width: 1024px)': {
            fontSize: 16,
        },
        '&:focus,&:hover': {
            outline: 'none',
            background: Constants.siteTheme.primaryTheme,
            color: '#fff',
        },
    },
    eirPaymentDialog: { justifyContent: 'center' },
}));
